export default __webpack_public_path__ + "static/media/9-decorated.476a8e64.webp";